export const realtorData = {
  email: 'javiles@unne.cl',
  phone:'984406305'
  // email: 'contacto@accionpanal.com',
};
